import { truncateName } from '@eika-infrastruktur/format';
import { LabelProps } from '@eika/label';

import type { EFakturaCreditorId, EFakturaGivenPermission } from '../../../../generated-types';
import { format } from '../../../../hooks/useTranslation';
import TranslationsConfigType from '../../../../translations/translationType';

export default (translated: TranslationsConfigType) =>
    (
        givenEfakturas: EFakturaGivenPermission[],
        creditorId: EFakturaCreditorId,
        userToBeUpdated?: EFakturaCreditorId,
    ): LabelProps[] | undefined => {
        const shared = givenEfakturas.filter(
            (given) =>
                given.selectedIssuers?.some((x) => x.creditorId.value === creditorId.value) ||
                given.selectedIssuers === undefined ||
                given.selectedIssuers.length === 0,
        );

        const given = userToBeUpdated ? shared.filter((x) => x.id.value !== userToBeUpdated.value) : shared;
        if (given.length > 2) {
            return [
                ...given.slice(0, 2).map((x) => ({
                    text: format(translated.eFakturaSharing.sharingWithPlaceholder, truncateName(x.disponentName)),
                })),
                { text: translated.eFakturaSharing.andMore },
            ];
        }

        return given.map((x) => ({
            text: format(translated.eFakturaSharing.sharingWithPlaceholder, truncateName(x.disponentName)),
        }));
    };
